{
  "PricingCalculator": {
    "enterSize": "Enter your size",
    "chooseSize": "Choose your size",
    "enterSizeDesc": "We can print any size from {{minWidth}}{{units}} to {{maxWidth}}{{units}}",
    "quantityLabel": "Custom Quantity",
    "quantityTooSmall": "Minimum order is {{moq}} pieces",
    "quantityHelperText": "Minimum order is {{moq}} pieces",
    "materialLabel": "Material",
    "shapeLabel": "Shape",
    "selectYourMaterial": "Select your material",
    "selectYourShape": "Select your shape",
    "quantityTitle": "Choose your quantity",
    "quantitySubtitle": "Minimum order for {{dimensions}} is {{moq}} pieces",
    "incTax": "prices inc VAT",
    "exTax": "prices excl VAT",
    "save": "Save",
    "uploadText": "Next, upload your artwork & our designers will make it print ready. We'll send a proof before printing.",
    "continue": "continue",
    "quantity": "Quantity",
    "customQuantityLabel": "Custom Quantity",
    "dimensions": "Dimensions",
    "bestseller": "Bestseller",
    "customize": "Customize",
    "addToCart": "Add to Cart"
  },
  "Dimensions": {
    "cm": "cm",
    "in": "in",
    "mm": "mm",
    "m": "m",
    "widthLabel": "Width",
    "widthTooSmall": "Min. {{minWidth}}{{units}} width.",
    "widthTooBig": "Max. {{maxWidth}}{{units}} width.",
    "widthHelperText": "Min {{minWidth}}{{units}}, max {{maxWidth}}{{units}}",
    "heightLabel": "Height",
    "heightTooSmall": "Min. {{minHeight}}{{units}} height.",
    "heightTooBig": "Max. {{maxHeight}}{{units}} height.",
    "heightHelperText": "Min {{minHeight}}{{units}}, max {{maxHeight}}{{units}}",
    "maxdp": "max dp"
  },
  "Materials": {
    "vinyl-white": {
      "name": "White Vinyl",
      "description": "Most popular",
      "sortOrder": 1,
      "bestseller": "Best seller"
    },
    "vinyl-clear": {
      "name": "Clear vinyl",
      "description": "Highly transparent",
      "sortOrder": 2
    },
    "holographic": {
      "name": "Holographic",
      "description": "Rainbow iridescent effect gives metallic colours",
      "sortOrder": 3
    },
    "glitter": {
      "name": "Glitter",
      "description": "Glitter effect creates sparkly colours",
      "sortOrder": 6
    },
    "paper-biodegradable": {
      "name": "Biodegradable Paper",
      "description": "Premium compostable paper with a matte finish"
    },
    "mirror-gold": {
      "name": "Mirror gold",
      "description": "Shiny gold chrome effect",
      "sortOrder": 5
    },
    "mirror-silver": {
      "name": "Mirror silver",
      "description": "Silver chrome effect gives metallic colours",
      "sortOrder": 4
    },
    "transfer-white": {
      "name": "White vinyl transfer",
      "description": "Cut from a single piece of white vinyl"
    },
    "transfer-black": {
      "name": "Black vinyl transfer",
      "description": "Cut from a single piece of black vinyl"
    },
    "magnet-white": {
      "name": "White (Standard)",
      "description": "Most popular, best for keeping your design true to the original colours"
    },
    "magnet-holo": {
      "name": "Holographic Magnet",
      "description": "Rainbow iridescent effect gives metallic colours"
    },
    "magnet-glitter": {
      "name": "Glitter Magnet",
      "description": "Glitter effect creates sparkly colours"
    },
    "magnet-silver": {
      "name": "Silver Magnet",
      "description": "Silver chrome effect for metallic colours"
    },
    "magnet-gold": {
      "name": "Gold Magnet",
      "description": "Shiny gold chrome effect"
    },
    "button-white": {
      "name": "White (Standard)",
      "description": "Most popular, best for keeping your design true to the original colours"
    },
    "button-holo": {
      "name": "Holographic",
      "description": "Rainbow iridescent effect gives metallic colours"
    },
    "button-glitter": {
      "name": "Glitter",
      "description": "Glitter effect creates sparkly colours"
    },
    "button-silver": {
      "name": "Mirror Silver",
      "description": "Silver chrome effect for metallic colours"
    },
    "button-gold": {
      "name": "Mirror Gold",
      "description": "Shiny gold chrome effect"
    }
  },
  "MaterialChooser": {
    "chooseYourMaterial": "Choose your material",
    "wePrintOn": "We print on these materials",
    "cancel": "Cancel",
    "continue": "Continue"
  },
  "StartDesign": {
    "uploadArtworkFeatures": [
      "Get a digital proof within 12 working hours.",
      "Upload up to {{maxDesigns}} designs at once, that are the same size.",
      "Submit high-quality files to get the perfect print."
    ],
    "uploadArtworkTitle": "Upload artwork",
    "uploadArtworkButtonText": "Upload my artwork",
    "uploadArtworkSkipText": "Skip and email later"
  },
  "ShapeChooser": {
    "title": "Choose your Shape",
    "cancel": "Cancel",
    "continue": "Continue"
  },
  "Shapes": {
    "custom": "Custom",
    "circle": "Circle",
    "oval": "Oval",
    "rectangular": "Rectangular",
    "rectangle": "Rectangular",
    "roundedcorner": "Rounded Corner",
    "square": "Square"
  },
  "Reorder": {
    "pageTitle": "Re-order",
    "subtitle": "Enter your details here to retrieve your past order",
    "orderNumberPlaceholder": "Order number",
    "emailPlaceholder": "Email",
    "submitButtonText": "Retrieve order",
    "helpText": "Can't find your order number? Login to see all of your designs & reorder"
  }
}
